// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2V22H2V2H22ZM6.65692 13.3719L18.3719 6.34292L17.3429 4.62793L9.45531 9.36049L7.38843 5.64012L5.64012 6.6114L7.73937 10.3901L5.62793 11.6569L6.65692 13.3719ZM16.2605 13.6098L18.3719 12.3429L17.3429 10.6279L5.62793 17.6569L6.65692 19.3719L14.5445 14.6393L16.6114 18.3597L18.3597 17.3884L16.2605 13.6098Z"}}]};

const StreetRoadFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'street-road-filled',
    ref,
    icon: element,
  },
));

StreetRoadFilledIcon.displayName = 'StreetRoadFilledIcon';

export default StreetRoadFilledIcon;
